export const ENTITIES_ADD = 'locations/ENTITIES_ADD';
export const NETWORK_START = 'locations/NETWORK_START';
export const NETWORK_RESET = 'locations/NETWORK_RESET';
export const NETWORK_ERROR = 'locations/NETWORK_ERROR';
export const ACTIVE_SET = 'locations/ACTIVE_SET';
export const SEARCH_SET = 'locations/SEARCH_SET';



// WEBPACK FOOTER //
// ./src/modules/locations/actionTypes.js